module.exports = __webpack_public_path__ + "img/home-header-image-2.bfa5d33c.png";